/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function getFirstNonDisabledItem(items) {
  var fistNonDisabledItemIndex = null;
  if (!items || items && !items.length) {
    return null;
  }
  for (var i = 0, len = items.length; i < len; i++) {
    var item = items[i];
    if (item && !item.disabled && !item.isTitle) {
      fistNonDisabledItemIndex = i;
      break;
    }
  }
  return fistNonDisabledItemIndex;
}
var _default = getFirstNonDisabledItem;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@inovua/reactdatagrid-community/packages/Menu/src/utils/getFirstNonDisabledItem.js
// module id = 702
// module chunks = 0